import React from 'react';
import { StyledLogo } from './header-logo.styled';

const HeaderLogoComponent = () => (
  <StyledLogo>
    <p>Amorim Cork Flooring</p>
  </StyledLogo>
);

export default HeaderLogoComponent;
